var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "anchorPoint_box",
    attrs: {
      id: "anchorPoint_box"
    }
  }, [_c("div", {
    class: ["anchorPoint"]
  }, _vm._l(_vm.titleArr, function (item, i) {
    return _c("a", {
      key: item + i,
      class: ["anchorPointItem"],
      style: {
        color: i == _vm.active ? _vm.formData.hoverTextColor : _vm.formData.textColor,
        fontSize: _vm.formData.fontSize + "px"
      },
      on: {
        click: function click($event) {
          return _vm.handleClick(i);
        }
      }
    }, [_vm._v(_vm._s(item.title))]);
  }), 0)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };